(function() {

  'use strict';

  angular.module('ringbaPortal')
    .controller('CallbacksController', CallbacksController);

  function CallbacksController(
    $filter,
    $scope,
    $uibModal,
    $timeout,
    $translate,
    accountsService,
    bsLoadingOverlayService,
    columnsFetchService,
    callbackService,
    isMobileDevice,
    toaster,
    utils,
    userSettingsService
  ) {

    const vm = this,
      currentAccountId = accountsService.currentAccountId;

    vm.columnSettings = callbackService.columnSettings;
    vm.userSettings = {};

    vm.$onInit = onInit;
    vm.dropSuccess = dropSuccess;
    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.onUpdate = onUpdate;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDelete = confirmDelete;
    vm.cancelDelete = cancelDelete;
    vm.cancelModal = cancelModal;
    vm.activateCallbackActions = activateCallbackActions;

    function onInit() {
      vm.isMobileView = isMobileDevice;
      vm.loading = true;
      vm.activeCallback = null;
      userSettingsService.getUserSettings()
        .then(function (userSettings){
          vm.userSettings = userSettings;
          vm.columns = columnsFetchService.getColumnList(userSettings, callbackService.defaultColumns, 'eventCallbacks');
          _loadEventCallBacks();
        })
        .catch(utils.errorHandler);
    }

    function dropSuccess (e, item, collection){
      // collection contains the current ordering of columns
      // after the drag and drop. We need to save the
      // collection in user settings under eventCallBacks key
      return userSettingsService.getUserSettings()
        .then(function (userSettings){
          vm.userSettings = userSettings;
          if (!vm.userSettings.eventCallbacks) {
            vm.userSettings.eventCallbacks = {};
          }
          vm.userSettings.eventCallbacks.columns = collection;
          return userSettingsService.saveUserSettings(vm.userSettings);
        });
    }

    function showForm(eventCallBack) {
      if (vm.activeCallback) hideForm(vm.activeCallback);
      vm.activeCallback = eventCallBack;
      if (eventCallBack) {
        vm.showAddNewForm = false;
        eventCallBack.showEditForm = true;
      } else {
        vm.showAddNewForm = true;
      }
      vm.activeActionCallbackId = false;
      vm.formActive = true;
    }

    function hideForm(eventCallBack) {
      if (eventCallBack) {
        eventCallBack.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
      vm.activeCallback = null;
    }

    function onUpdate(newCallback) {
      _loadEventCallBacks();
      hideForm();
      if (newCallback) {
        toaster.pop('success', $filter('translate')('PIXELS_CREATE_SUCCESS'));
      }
    }

    function activateCallbackActions(callbackId) {
      vm.activeActionCallbackId = vm.activeActionCallbackId == callbackId ? false : callbackId;
    }

    function confirmDeleteModal(callback) {
      if (!vm.formActive) {
        vm.callbackReferences = null;
        vm.callbackForDelete = callback;
        _getCallbackReferences(callback.id);
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/callbacks/delete-callback.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function confirmDelete() {
      return callbackService.deleteEventCallBack(currentAccountId, vm.callbackForDelete.id).then(
        function () {
          _.remove(vm.eventCallBacks, function (callback) {
            return callback.id === vm.callbackForDelete.id;
          });
          toaster.pop('success', $translate.instant('PIXEL_DELETE_SUCCESS'));
          cancelModal();
        }).catch(utils.errorHandler);
    }

    function cancelDelete() {
      cancelModal();
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.callbackForDelete = null;
      }
    }

    function _loadEventCallBacks() {
      callbackService.getEventCallBacks(currentAccountId)
        .then(function (response) {
          vm.eventCallBacks = response.data.eventCallBacks;
          vm.loading = false;
          _normalizeEventCallBacks();
        })
        .catch(utils.errorHandler);
    }

    function _normalizeEventCallBacks() {
      if (vm.eventCallBacks) {
        _.each(vm.eventCallBacks, function (item) {
          item.method = item.method.toUpperCase();
          item.advanced = item.method.toUpperCase() != 'GET' || (item.headers != null && Object.keys(item.headers).length > 0);
        });
      }
    }

    function _getCallbackReferences(callbackId) {
      vm.checkReferencesText = 'DELETE_CALLBACK_MODAL_CHECK_ASSOCIATION_TEXT';
      bsLoadingOverlayService.start();
      callbackService.getReferences(currentAccountId, callbackId).then(function (response) {
        // We're using timeout here to show the user the checking callback references text
        $timeout(function () {
          bsLoadingOverlayService.stop();
          vm.callbackReferences = response.data;
        }, 800);
      }).catch(function () {
        vm.checkReferencesText = 'DELETE_CALLBACK_MODAL_CHECK_ASSOCIATION_ERROR_TEXT';
        bsLoadingOverlayService.stop();
      });
    }

    // Watch the items displayed in the table, if there is an active item when it changes, hide the edit form and clear active item
    $scope.$watch('vm.displayEventCallBacks', function() {
      if (vm.activeCallback) hideForm(vm.activeCallback);
      vm.showAddNewForm = false;
      vm.formActive = false;
    });
  }

})();
